export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20digital%20entertainment%20media%20visualization%20with%20flowing%20warm%20gradients%20in%20coral%20orange%20and%20deep%20amber%20tones%2C%20stylized%20data%20streams%20and%20overlapping%20semi-transparent%20panels%2C%20modern%20editorial%20design%20aesthetic%2C%20dynamic%20composition%20with%20soft%20glow%20effects%2C%20dark%20atmospheric%20background%20with%20warm%20accents%2C%20professional%20illustration%20style&width=1600&height=900&seq=hero-main-bg&orientation=landscape"
          alt="吃瓜视频在线观看 - 全网热门八卦资讯平台"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-background-950/90 via-background-950/70 to-background-950/40"></div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-500/20 text-primary-300 text-xs font-label border border-primary-500/30 mb-5">
              <i className="ri-fire-line text-sm"></i>
              在线吃瓜 · 每日更新
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 leading-tight">
              吃瓜视频在线观看
              <span className="block text-primary-400 text-xl md:text-2xl lg:text-3xl mt-2 font-normal">
                全网八卦一网打尽
              </span>
            </h1>

            <p className="text-base md:text-lg text-background-300 mt-5 leading-relaxed max-w-[640px] mx-auto lg:mx-0">
              汇聚51吃瓜在线、吃瓜在线等平台优质内容，覆盖娱乐圈、网红圈、社会热点等多领域八卦资讯。吃瓜群众在线的首选阵地，瓜田每日更新，最新最全吃瓜内容一手掌握，让你随时随地满足在线吃瓜需求。
            </p>

            <p className="text-sm text-background-400 mt-4 leading-relaxed max-w-[640px] mx-auto lg:mx-0">
              本站内容每日更新，当前已收录超过数千条热门八卦话题，覆盖主流吃瓜平台的精华内容，从明星动态到综艺爆料，从网红八卦到社会热议，满足吃瓜群众看热闹的全部需求。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mt-6">
              <div className="flex items-center gap-2 text-sm text-background-300">
                <i className="ri-timer-flash-line text-primary-400"></i>
                <span>每日更新300+条</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-background-300">
                <i className="ri-hashtag text-accent-400"></i>
                <span>覆盖50+热门话题</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-background-300">
                <i className="ri-group-line text-primary-400"></i>
                <span>千万吃瓜群众聚集</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <button
                onClick={() => scrollTo('#index')}
                className="w-full sm:w-auto px-8 py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 font-label font-medium text-sm transition-all cursor-pointer whitespace-nowrap"
              >
                立即吃瓜
                <i className="ri-arrow-right-line ml-2"></i>
              </button>
              <button
                onClick={() => scrollTo('#ranking')}
                className="w-full sm:w-auto px-8 py-3 rounded-full border border-background-400/30 hover:border-primary-400/50 text-background-200 hover:text-primary-300 font-label text-sm transition-all cursor-pointer whitespace-nowrap"
              >
                热门榜单
                <i className="ri-arrow-right-line ml-2"></i>
              </button>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[520px] lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3] bg-background-800">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20digital%20entertainment%20content%20collage%20with%20abstract%20news%20headlines%20and%20trending%20topic%20indicators%2C%20stylized%20gossip%20media%20concept%20with%20warm%20coral%20and%20amber%20color%20scheme%2C%20editorial%20layout%20with%20overlapping%20image%20panels%20and%20text%20elements%2C%20sophisticated%20design%20with%20soft%20gradients%2C%20professional%20visual%20style&width=1200&height=900&seq=hero-visual-01&orientation=landscape"
                alt="吃瓜视频在线观看 - 热门八卦内容展示"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/40 to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-2">
                <span className="px-2.5 py-1 rounded-full bg-primary-500/80 text-background-50 text-xs font-label whitespace-nowrap">🔥 正在热传</span>
                <span className="px-2.5 py-1 rounded-full bg-background-950/60 text-background-200 text-xs font-label whitespace-nowrap">今日更新</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}